import axios from "axios";
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API });
http.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("oh_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
export const money = (n) => `£${Number(n || 0).toFixed(2)}`;
export const LOGO_WORDMARK = "https://customer-assets-v7afamib.emergentagent.net/job_healing-shop-2/artifacts/kyq40i7r_Logo1.png";
export const LOGO_MOUNTAIN = "https://customer-assets-v7afamib.emergentagent.net/job_healing-shop-2/artifacts/51ow55n8_logo2.png";
